// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Restaurant_Types_Id from "../Restaumatic.Restaurant.Types.Id/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Restaurant_Types_Id.eqRestaurantId);
var restaurantIdIsSymbol = {
    reflectSymbol: function () {
        return "restaurantId";
    }
};
var GetPaymentChannelsRequestIsSymbol = {
    reflectSymbol: function () {
        return "GetPaymentChannelsRequest";
    }
};
var GetPaymentChannelsRequest = function (x) {
    return x;
};
var toFillFormTypeGetPaymentC = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var rPCSitesGetPaymentChannel = {};
var rPCMethodNameGetPaymentCh = {
    rpcMethodName: function (v) {
        return "GetPaymentChannelsRequest";
    }
};
var newtypeGetPaymentChannels = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldGetPaymentChannel = function (dictHasField) {
    return dictHasField;
};
var eqGetPaymentChannelsReque = {
    eq: function (x) {
        return function (y) {
            return eq(x.restaurantId)(y.restaurantId);
        };
    }
};
var genericGetPaymentChannelsRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showGetPaymentChannelsRequest = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericGetPaymentChannelsRequest)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(restaurantIdIsSymbol)(Restaumatic_Restaurant_Types_Id.showRestaurantId))))(GetPaymentChannelsRequestIsSymbol))
};
var unscrambleDecodeGetPaymentChannelsRequest = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericGetPaymentChannelsRequest)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(restaurantIdIsSymbol)(Restaumatic_Restaurant_Types_Id.udecodeRestaurantId)(Unscramble.decodeRecordNil)))))(Unscramble_Generic.defaultOptions)
};
var encodeGetPaymentChannelsRequest = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericGetPaymentChannelsRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(GetPaymentChannelsRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)(restaurantIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.encodeRestaurantId))))))
};
var decodeGetPaymentChannelsRequest = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericGetPaymentChannelsRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(GetPaymentChannelsRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)(restaurantIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.decodeRestaurantId))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    GetPaymentChannelsRequest,
    genericGetPaymentChannelsRequest,
    eqGetPaymentChannelsReque,
    showGetPaymentChannelsRequest,
    rPCMethodNameGetPaymentCh,
    rPCSitesGetPaymentChannel,
    encodeGetPaymentChannelsRequest,
    decodeGetPaymentChannelsRequest,
    unscrambleDecodeGetPaymentChannelsRequest,
    toFillFormTypeGetPaymentC,
    hasFieldGetPaymentChannel,
    newtypeGetPaymentChannels
};
